<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

import { useI18n } from 'vue-i18n';
defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  createdBy: {
    type: Object,
    default: null,
  },
  audienceCount: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();
</script>

<template>
  <span
    v-if="createdBy?.name"
    class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap"
  >
    {{
      t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.CREATED_BY', {
        name: createdBy.name,
      })
    }}
  </span>
  <span
    v-if="audienceCount > 0"
    class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap"
  >
    {{
      t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.AUDIENCE_COUNT', {
        count: audienceCount,
      })
    }}
  </span>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
    {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
  </span>
</template>
